var He = Object.defineProperty;
var J = Object.getOwnPropertySymbols;
var ze = Object.prototype.hasOwnProperty, ke = Object.prototype.propertyIsEnumerable;
var Q = (e, r, t) => r in e ? He(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ee = (e, r) => {
  for (var t in r || (r = {}))
    ze.call(r, t) && Q(e, t, r[t]);
  if (J)
    for (var t of J(r))
      ke.call(r, t) && Q(e, t, r[t]);
  return e;
};
import { $emit as P } from "../utils/gogocodeTransfer.js";
import { g as We } from "../_commonjsHelpers-ce4d82cc.js";
import { _ as k, a as Ee, b as Ce, e as Xe, i as I, c as Ye, d as D, f as Ze, h as Je, j as W, k as Qe, l as xe, m as er, g as N } from "../get-2ba9bcdb.js";
import { _ as m, b as rr, c as X, d as R, e as tr, i as ar } from "../isSymbol-62c14278.js";
import { t as nr } from "../toNumber-ea93c45b.js";
import { ElSelect as ir, ElOption as sr } from "element-plus";
import { resolveComponent as re, openBlock as S, createElementBlock as G, createVNode as F, normalizeStyle as te, withCtx as ae, Fragment as ne, renderList as ie, createBlock as se, createTextVNode as or } from "vue";
import { _ as ur } from "../_plugin-vue_export-helper-dad06003.js";
function lr(e, r, t, a) {
  for (var i = e.length, n = t + (a ? 1 : -1); a ? n-- : ++n < i; )
    if (r(e[n], n, e))
      return n;
  return -1;
}
var fr = lr, cr = k;
function gr() {
  this.__data__ = new cr(), this.size = 0;
}
var vr = gr;
function dr(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
var pr = dr;
function yr(e) {
  return this.__data__.get(e);
}
var _r = yr;
function br(e) {
  return this.__data__.has(e);
}
var hr = br, $r = k, mr = Ee, Ar = Ce, Tr = 200;
function Pr(e, r) {
  var t = this.__data__;
  if (t instanceof $r) {
    var a = t.__data__;
    if (!mr || a.length < Tr - 1)
      return a.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new Ar(a);
  }
  return t.set(e, r), this.size = t.size, this;
}
var Sr = Pr, Ir = k, Or = vr, wr = pr, Er = _r, Cr = hr, xr = Sr;
function A(e) {
  var r = this.__data__ = new Ir(e);
  this.size = r.size;
}
A.prototype.clear = Or;
A.prototype.delete = wr;
A.prototype.get = Er;
A.prototype.has = Cr;
A.prototype.set = xr;
var Le = A, Lr = "__lodash_hash_undefined__";
function Mr(e) {
  return this.__data__.set(e, Lr), this;
}
var Dr = Mr;
function Rr(e) {
  return this.__data__.has(e);
}
var Nr = Rr, Gr = Ce, Fr = Dr, jr = Nr;
function x(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new Gr(); ++r < t; )
    this.add(e[r]);
}
x.prototype.add = x.prototype.push = Fr;
x.prototype.has = jr;
var Br = x;
function Ur(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length; ++t < a; )
    if (r(e[t], t, e))
      return !0;
  return !1;
}
var Kr = Ur;
function Vr(e, r) {
  return e.has(r);
}
var qr = Vr, Hr = Br, zr = Kr, kr = qr, Wr = 1, Xr = 2;
function Yr(e, r, t, a, i, n) {
  var s = t & Wr, u = e.length, o = r.length;
  if (u != o && !(s && o > u))
    return !1;
  var l = n.get(e), v = n.get(r);
  if (l && v)
    return l == r && v == e;
  var g = -1, c = !0, y = t & Xr ? new Hr() : void 0;
  for (n.set(e, r), n.set(r, e); ++g < u; ) {
    var d = e[g], p = r[g];
    if (a)
      var _ = s ? a(p, d, g, r, e, n) : a(d, p, g, e, r, n);
    if (_ !== void 0) {
      if (_)
        continue;
      c = !1;
      break;
    }
    if (y) {
      if (!zr(r, function(b, h) {
        if (!kr(y, h) && (d === b || i(d, b, t, a, n)))
          return y.push(h);
      })) {
        c = !1;
        break;
      }
    } else if (!(d === p || i(d, p, t, a, n))) {
      c = !1;
      break;
    }
  }
  return n.delete(e), n.delete(r), c;
}
var Me = Yr, Zr = m, Jr = Zr.Uint8Array, Qr = Jr;
function et(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(a, i) {
    t[++r] = [i, a];
  }), t;
}
var rt = et;
function tt(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(a) {
    t[++r] = a;
  }), t;
}
var at = tt, oe = rr, ue = Qr, nt = Xe, it = Me, st = rt, ot = at, ut = 1, lt = 2, ft = "[object Boolean]", ct = "[object Date]", gt = "[object Error]", vt = "[object Map]", dt = "[object Number]", pt = "[object RegExp]", yt = "[object Set]", _t = "[object String]", bt = "[object Symbol]", ht = "[object ArrayBuffer]", $t = "[object DataView]", le = oe ? oe.prototype : void 0, j = le ? le.valueOf : void 0;
function mt(e, r, t, a, i, n, s) {
  switch (t) {
    case $t:
      if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
        return !1;
      e = e.buffer, r = r.buffer;
    case ht:
      return !(e.byteLength != r.byteLength || !n(new ue(e), new ue(r)));
    case ft:
    case ct:
    case dt:
      return nt(+e, +r);
    case gt:
      return e.name == r.name && e.message == r.message;
    case pt:
    case _t:
      return e == r + "";
    case vt:
      var u = st;
    case yt:
      var o = a & ut;
      if (u || (u = ot), e.size != r.size && !o)
        return !1;
      var l = s.get(e);
      if (l)
        return l == r;
      a |= lt, s.set(e, r);
      var v = it(u(e), u(r), a, i, n, s);
      return s.delete(e), v;
    case bt:
      if (j)
        return j.call(e) == j.call(r);
  }
  return !1;
}
var At = mt;
function Tt(e, r) {
  for (var t = -1, a = r.length, i = e.length; ++t < a; )
    e[i + t] = r[t];
  return e;
}
var Pt = Tt, St = Pt, It = I;
function Ot(e, r, t) {
  var a = r(e);
  return It(e) ? a : St(a, t(e));
}
var wt = Ot;
function Et(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length, i = 0, n = []; ++t < a; ) {
    var s = e[t];
    r(s, t, e) && (n[i++] = s);
  }
  return n;
}
var Ct = Et;
function xt() {
  return [];
}
var Lt = xt, Mt = Ct, Dt = Lt, Rt = Object.prototype, Nt = Rt.propertyIsEnumerable, fe = Object.getOwnPropertySymbols, Gt = fe ? function(e) {
  return e == null ? [] : (e = Object(e), Mt(fe(e), function(r) {
    return Nt.call(e, r);
  }));
} : Dt, Ft = Gt;
function jt(e, r) {
  for (var t = -1, a = Array(e); ++t < e; )
    a[t] = r(t);
  return a;
}
var Bt = jt, Ut = X, Kt = R, Vt = "[object Arguments]";
function qt(e) {
  return Kt(e) && Ut(e) == Vt;
}
var Ht = qt, ce = Ht, zt = R, De = Object.prototype, kt = De.hasOwnProperty, Wt = De.propertyIsEnumerable, Xt = ce(function() {
  return arguments;
}()) ? ce : function(e) {
  return zt(e) && kt.call(e, "callee") && !Wt.call(e, "callee");
}, Re = Xt, L = { exports: {} };
function Yt() {
  return !1;
}
var Zt = Yt;
L.exports;
(function(e, r) {
  var t = m, a = Zt, i = r && !r.nodeType && r, n = i && !0 && e && !e.nodeType && e, s = n && n.exports === i, u = s ? t.Buffer : void 0, o = u ? u.isBuffer : void 0, l = o || a;
  e.exports = l;
})(L, L.exports);
var Ne = L.exports, Jt = 9007199254740991, Qt = /^(?:0|[1-9]\d*)$/;
function ea(e, r) {
  var t = typeof e;
  return r = r == null ? Jt : r, !!r && (t == "number" || t != "symbol" && Qt.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var Ge = ea, ra = 9007199254740991;
function ta(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ra;
}
var Y = ta, aa = X, na = Y, ia = R, sa = "[object Arguments]", oa = "[object Array]", ua = "[object Boolean]", la = "[object Date]", fa = "[object Error]", ca = "[object Function]", ga = "[object Map]", va = "[object Number]", da = "[object Object]", pa = "[object RegExp]", ya = "[object Set]", _a = "[object String]", ba = "[object WeakMap]", ha = "[object ArrayBuffer]", $a = "[object DataView]", ma = "[object Float32Array]", Aa = "[object Float64Array]", Ta = "[object Int8Array]", Pa = "[object Int16Array]", Sa = "[object Int32Array]", Ia = "[object Uint8Array]", Oa = "[object Uint8ClampedArray]", wa = "[object Uint16Array]", Ea = "[object Uint32Array]", f = {};
f[ma] = f[Aa] = f[Ta] = f[Pa] = f[Sa] = f[Ia] = f[Oa] = f[wa] = f[Ea] = !0;
f[sa] = f[oa] = f[ha] = f[ua] = f[$a] = f[la] = f[fa] = f[ca] = f[ga] = f[va] = f[da] = f[pa] = f[ya] = f[_a] = f[ba] = !1;
function Ca(e) {
  return ia(e) && na(e.length) && !!f[aa(e)];
}
var xa = Ca;
function La(e) {
  return function(r) {
    return e(r);
  };
}
var Ma = La, M = { exports: {} };
M.exports;
(function(e, r) {
  var t = tr, a = r && !r.nodeType && r, i = a && !0 && e && !e.nodeType && e, n = i && i.exports === a, s = n && t.process, u = function() {
    try {
      var o = i && i.require && i.require("util").types;
      return o || s && s.binding && s.binding("util");
    } catch (l) {
    }
  }();
  e.exports = u;
})(M, M.exports);
var Da = M.exports, Ra = xa, Na = Ma, ge = Da, ve = ge && ge.isTypedArray, Ga = ve ? Na(ve) : Ra, Fe = Ga, Fa = Bt, ja = Re, Ba = I, Ua = Ne, Ka = Ge, Va = Fe, qa = Object.prototype, Ha = qa.hasOwnProperty;
function za(e, r) {
  var t = Ba(e), a = !t && ja(e), i = !t && !a && Ua(e), n = !t && !a && !i && Va(e), s = t || a || i || n, u = s ? Fa(e.length, String) : [], o = u.length;
  for (var l in e)
    (r || Ha.call(e, l)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    n && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Ka(l, o))) && u.push(l);
  return u;
}
var ka = za, Wa = Object.prototype;
function Xa(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || Wa;
  return e === t;
}
var Ya = Xa;
function Za(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var Ja = Za, Qa = Ja, en = Qa(Object.keys, Object), rn = en, tn = Ya, an = rn, nn = Object.prototype, sn = nn.hasOwnProperty;
function on(e) {
  if (!tn(e))
    return an(e);
  var r = [];
  for (var t in Object(e))
    sn.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
var un = on, ln = Ye, fn = Y;
function cn(e) {
  return e != null && fn(e.length) && !ln(e);
}
var gn = cn, vn = ka, dn = un, pn = gn;
function yn(e) {
  return pn(e) ? vn(e) : dn(e);
}
var je = yn, _n = wt, bn = Ft, hn = je;
function $n(e) {
  return _n(e, hn, bn);
}
var mn = $n, de = mn, An = 1, Tn = Object.prototype, Pn = Tn.hasOwnProperty;
function Sn(e, r, t, a, i, n) {
  var s = t & An, u = de(e), o = u.length, l = de(r), v = l.length;
  if (o != v && !s)
    return !1;
  for (var g = o; g--; ) {
    var c = u[g];
    if (!(s ? c in r : Pn.call(r, c)))
      return !1;
  }
  var y = n.get(e), d = n.get(r);
  if (y && d)
    return y == r && d == e;
  var p = !0;
  n.set(e, r), n.set(r, e);
  for (var _ = s; ++g < o; ) {
    c = u[g];
    var b = e[c], h = r[c];
    if (a)
      var Z = s ? a(h, b, c, r, e, n) : a(b, h, c, e, r, n);
    if (!(Z === void 0 ? b === h || i(b, h, t, a, n) : Z)) {
      p = !1;
      break;
    }
    _ || (_ = c == "constructor");
  }
  if (p && !_) {
    var O = e.constructor, w = r.constructor;
    O != w && "constructor" in e && "constructor" in r && !(typeof O == "function" && O instanceof O && typeof w == "function" && w instanceof w) && (p = !1);
  }
  return n.delete(e), n.delete(r), p;
}
var In = Sn, On = D, wn = m, En = On(wn, "DataView"), Cn = En, xn = D, Ln = m, Mn = xn(Ln, "Promise"), Dn = Mn, Rn = D, Nn = m, Gn = Rn(Nn, "Set"), Fn = Gn, jn = D, Bn = m, Un = jn(Bn, "WeakMap"), Kn = Un, K = Cn, V = Ee, q = Dn, H = Fn, z = Kn, Be = X, T = Ze, pe = "[object Map]", Vn = "[object Object]", ye = "[object Promise]", _e = "[object Set]", be = "[object WeakMap]", he = "[object DataView]", qn = T(K), Hn = T(V), zn = T(q), kn = T(H), Wn = T(z), $ = Be;
(K && $(new K(new ArrayBuffer(1))) != he || V && $(new V()) != pe || q && $(q.resolve()) != ye || H && $(new H()) != _e || z && $(new z()) != be) && ($ = function(e) {
  var r = Be(e), t = r == Vn ? e.constructor : void 0, a = t ? T(t) : "";
  if (a)
    switch (a) {
      case qn:
        return he;
      case Hn:
        return pe;
      case zn:
        return ye;
      case kn:
        return _e;
      case Wn:
        return be;
    }
  return r;
});
var Xn = $, B = Le, Yn = Me, Zn = At, Jn = In, $e = Xn, me = I, Ae = Ne, Qn = Fe, ei = 1, Te = "[object Arguments]", Pe = "[object Array]", E = "[object Object]", ri = Object.prototype, Se = ri.hasOwnProperty;
function ti(e, r, t, a, i, n) {
  var s = me(e), u = me(r), o = s ? Pe : $e(e), l = u ? Pe : $e(r);
  o = o == Te ? E : o, l = l == Te ? E : l;
  var v = o == E, g = l == E, c = o == l;
  if (c && Ae(e)) {
    if (!Ae(r))
      return !1;
    s = !0, v = !1;
  }
  if (c && !v)
    return n || (n = new B()), s || Qn(e) ? Yn(e, r, t, a, i, n) : Zn(e, r, o, t, a, i, n);
  if (!(t & ei)) {
    var y = v && Se.call(e, "__wrapped__"), d = g && Se.call(r, "__wrapped__");
    if (y || d) {
      var p = y ? e.value() : e, _ = d ? r.value() : r;
      return n || (n = new B()), i(p, _, t, a, n);
    }
  }
  return c ? (n || (n = new B()), Jn(e, r, t, a, i, n)) : !1;
}
var ai = ti, ni = ai, Ie = R;
function Ue(e, r, t, a, i) {
  return e === r ? !0 : e == null || r == null || !Ie(e) && !Ie(r) ? e !== e && r !== r : ni(e, r, t, a, Ue, i);
}
var Ke = Ue, ii = Le, si = Ke, oi = 1, ui = 2;
function li(e, r, t, a) {
  var i = t.length, n = i, s = !a;
  if (e == null)
    return !n;
  for (e = Object(e); i--; ) {
    var u = t[i];
    if (s && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++i < n; ) {
    u = t[i];
    var o = u[0], l = e[o], v = u[1];
    if (s && u[2]) {
      if (l === void 0 && !(o in e))
        return !1;
    } else {
      var g = new ii();
      if (a)
        var c = a(l, v, o, e, r, g);
      if (!(c === void 0 ? si(v, l, oi | ui, a, g) : c))
        return !1;
    }
  }
  return !0;
}
var fi = li, ci = ar;
function gi(e) {
  return e === e && !ci(e);
}
var Ve = gi, vi = Ve, di = je;
function pi(e) {
  for (var r = di(e), t = r.length; t--; ) {
    var a = r[t], i = e[a];
    r[t] = [a, i, vi(i)];
  }
  return r;
}
var yi = pi;
function _i(e, r) {
  return function(t) {
    return t == null ? !1 : t[e] === r && (r !== void 0 || e in Object(t));
  };
}
var qe = _i, bi = fi, hi = yi, $i = qe;
function mi(e) {
  var r = hi(e);
  return r.length == 1 && r[0][2] ? $i(r[0][0], r[0][1]) : function(t) {
    return t === e || bi(t, e, r);
  };
}
var Ai = mi;
function Ti(e, r) {
  return e != null && r in Object(e);
}
var Pi = Ti, Si = Je, Ii = Re, Oi = I, wi = Ge, Ei = Y, Ci = W;
function xi(e, r, t) {
  r = Si(r, e);
  for (var a = -1, i = r.length, n = !1; ++a < i; ) {
    var s = Ci(r[a]);
    if (!(n = e != null && t(e, s)))
      break;
    e = e[s];
  }
  return n || ++a != i ? n : (i = e == null ? 0 : e.length, !!i && Ei(i) && wi(s, i) && (Oi(e) || Ii(e)));
}
var Li = xi, Mi = Pi, Di = Li;
function Ri(e, r) {
  return e != null && Di(e, r, Mi);
}
var Ni = Ri, Gi = Ke, Fi = Qe, ji = Ni, Bi = xe, Ui = Ve, Ki = qe, Vi = W, qi = 1, Hi = 2;
function zi(e, r) {
  return Bi(e) && Ui(r) ? Ki(Vi(e), r) : function(t) {
    var a = Fi(t, e);
    return a === void 0 && a === r ? ji(t, e) : Gi(r, a, qi | Hi);
  };
}
var ki = zi;
function Wi(e) {
  return e;
}
var Xi = Wi;
function Yi(e) {
  return function(r) {
    return r == null ? void 0 : r[e];
  };
}
var Zi = Yi, Ji = er;
function Qi(e) {
  return function(r) {
    return Ji(r, e);
  };
}
var es = Qi, rs = Zi, ts = es, as = xe, ns = W;
function is(e) {
  return as(e) ? rs(ns(e)) : ts(e);
}
var ss = is, os = Ai, us = ki, ls = Xi, fs = I, cs = ss;
function gs(e) {
  return typeof e == "function" ? e : e == null ? ls : typeof e == "object" ? fs(e) ? us(e[0], e[1]) : os(e) : cs(e);
}
var vs = gs, ds = nr, Oe = 1 / 0, ps = 17976931348623157e292;
function ys(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = ds(e), e === Oe || e === -Oe) {
    var r = e < 0 ? -1 : 1;
    return r * ps;
  }
  return e === e ? e : 0;
}
var _s = ys, bs = _s;
function hs(e) {
  var r = bs(e), t = r % 1;
  return r === r ? t ? r - t : r : 0;
}
var $s = hs, ms = fr, As = vs, Ts = $s, Ps = Math.max;
function Ss(e, r, t) {
  var a = e == null ? 0 : e.length;
  if (!a)
    return -1;
  var i = t == null ? 0 : Ts(t);
  return i < 0 && (i = Ps(a + i, 0)), ms(e, As(r), i);
}
var Is = Ss;
const we = /* @__PURE__ */ We(Is), C = "", Os = {
  name: "rSymbolPicker",
  components: {
    Select: ir,
    Option: sr
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /**
     * 选择框值，labelInValue为true时，value为 xxx/xxx，否则是symbolId
     */
    modelValue: {
      type: [Number, String],
      default: ""
    },
    /**
     * 选择框数据
     */
    data: {
      type: Array,
      default: () => []
    },
    /**
     * 选择框尺寸
     */
    size: {
      type: String,
      default: "default"
    },
    /**
     * 选择框宽度
     */
    width: {
      type: Number,
      default: 120
    },
    /**
     * 默认左侧coin值
     */
    defaultLeftCoinValue: {
      type: String,
      default: ""
    },
    /**
     * value将返回获得选项的文本，而不是symbolId
     */
    labelInValue: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    currentTradingPair() {
      if (this.coin === C)
        return [
          {
            symbol: C,
            groupName: this.$t("bmui-symbol-picker.all")
          }
        ];
      {
        const e = we(this.data, ["coin", this.coin]);
        return e >= 0 ? N(this.data, [e, "tradingPair"], []) : [];
      }
    },
    symbolMap() {
      return this.data.reduce((e, r) => Object.assign(
        e,
        r.tradingPair.reduce((t, a) => Object.assign(t, {
          [a.symbol]: ee({
            coin: r.coin
          }, a)
        }), {})
      ), {});
    },
    symbolValue() {
      if (!this.modelValue)
        return "";
      if (!this.labelInValue)
        return this.modelValue;
      if (this.currentPairData) {
        const e = this.modelValue.split("/")[1], t = N(this.currentPairData, "tradingPair", []).find((a) => a.groupName === e);
        return (t == null ? void 0 : t.symbol) || "";
      }
      return "";
    },
    currentPairData() {
      if (!this.coin)
        return null;
      const e = we(this.data, ["coin", this.coin]);
      return e >= 0 ? this.data[e] : null;
    }
  },
  data() {
    return {
      coin: this.defaultLeftCoinValue
    };
  },
  watch: {
    value(e) {
      this.fillValue(e);
    },
    data(e) {
      e.length > 0 && this.modelValue && this.fillValue(this.modelValue);
    }
  },
  mounted() {
    this.fillValue(this.modelValue);
  },
  methods: {
    fillValue(e) {
      if (e && this.symbolMap[e]) {
        const r = this.symbolMap[e];
        this.coin = r.coin;
      }
    },
    handleChangeCoin(e) {
      var r, t;
      if (e === C)
        P(this, "update:modelValue", C);
      else if (this.labelInValue) {
        if (this.currentPairData) {
          const a = `${this.currentPairData.coin}/${(r = this.currentPairData) == null ? void 0 : r.tradingPair[0].groupName}`;
          P(this, "update:modelValue", a);
        }
      } else
        (t = this.currentTradingPair) != null && t.length && P(this, "update:modelValue", this.currentTradingPair[0].symbol);
    },
    handleChangeSymbol(e) {
      if (!this.labelInValue) {
        P(this, "update:modelValue", e);
        return;
      }
      const t = N(this.currentPairData, "tradingPair", []).find((i) => i.symbol === e), a = `${this.currentPairData.coin}/${t.groupName}`;
      P(this, "update:modelValue", a);
    }
  },
  emits: [
    {
      /**
       * 改变
       */
      change: (e) => e
    },
    "change",
    "update:modelValue"
  ]
};
function ws(e, r, t, a, i, n) {
  const s = re("Option"), u = re("Select");
  return S(), G("div", null, [
    F(u, {
      modelValue: i.coin,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => i.coin = o),
      onChange: n.handleChangeCoin,
      size: t.size,
      style: te(`width: ${t.width}px`),
      "no-data-text": e.$t("bmui-symbol-picker.nofavorites"),
      filterable: ""
    }, {
      default: ae(() => [
        F(s, {
          label: e.$t("bmui-symbol-picker.all"),
          value: ""
        }, null, 8, ["label"]),
        (S(!0), G(
          ne,
          null,
          ie(t.data, (o) => (S(), se(s, {
            key: o.coin,
            label: o.coin,
            value: o.coin
          }, null, 8, ["label", "value"]))),
          128
          /* KEYED_FRAGMENT */
        ))
      ]),
      _: 1
      /* STABLE */
    }, 8, ["modelValue", "onChange", "size", "style", "no-data-text"]),
    or(" / "),
    F(u, {
      "model-value": t.data.length > 0 ? n.symbolValue : "",
      onChange: n.handleChangeSymbol,
      size: t.size,
      style: te(`width: ${t.width}px`),
      "no-data-text": e.$t("bmui-symbol-picker.nofavorites"),
      filterable: ""
    }, {
      default: ae(() => [
        (S(!0), G(
          ne,
          null,
          ie(n.currentTradingPair, (o) => (S(), se(s, {
            key: o.symbol,
            label: o.groupName,
            value: o.symbol
          }, null, 8, ["label", "value"]))),
          128
          /* KEYED_FRAGMENT */
        ))
      ]),
      _: 1
      /* STABLE */
    }, 8, ["model-value", "onChange", "size", "style", "no-data-text"])
  ]);
}
const U = /* @__PURE__ */ ur(Os, [["render", ws], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/symbol-picker/symbol-picker.vue"]]);
U.install = function(e) {
  e.component(U.name, U);
};
export {
  U as default
};
